import Call from '../Call';

const SSRotator = {
    get() {
        return Call(`ssRotator`);
    },

    save(zone, ssId) {
        return Call('ssRotator','POST', { zone, ssId });
    }
};

export default SSRotator;


// WEBPACK FOOTER //
// ./src/services/API/components/SSRotator.js